module.exports = {"screenLoader.general":"Probíhá načítání sekce obecné..."}